<ion-app>
  <div #mainAppContainer class="tl-main-app-container">
    <ion-router-outlet></ion-router-outlet>
  </div>
</ion-app>
